import StockAndPriceData from '../model/stock-and-price-data';
import MessageHelper from './message-helper';
import { RowReader } from './row-reader';

// eslint-disable-next-line import/prefer-default-export
export class CartStateManager {
  static update(
    row: JQuery,
    data: StockAndPriceData,
    qtyInput: JQuery<HTMLInputElement> | null,
  ): void {
    if (!qtyInput?.data('reactive')) return;

    const {
      isArchived,
      isDirectDelivery,
      isMasterClass,
      isPhasedOut,
      isTireOrWheel,
      hasSubstitution,
    } = RowReader.readProductFlags(row);

    const externalStock = isTireOrWheel && isDirectDelivery
      ? data.warehouses
        .filter((w) => w.type === 'EXTERNAL')
        .reduce((acc, w) => acc + w.stockLevelAmount, 0)
      : 0;

    const forecastStock = isPhasedOut && data.stockForecasts
      ? data.stockForecasts
        .filter((f) => !f.unknownForecast)
        .reduce((acc, f) => acc + f.quantity, 0)
      : 0;

    const isNotInStock = (isArchived && !hasSubstitution)
      || (isDirectDelivery && isTireOrWheel && externalStock === 0)
      || (isMasterClass && isPhasedOut && forecastStock === 0);

    if (isNotInStock) {
      RowReader.ownDescendants(row, '.js-qty-selector').addClass('-disabled');
      RowReader.ownDescendants(row, '.js-addToCart').prop('disabled', true);
    } else {
      RowReader.ownDescendants(row, '.js-qty-selector').removeClass('-disabled');
      RowReader.ownDescendants(row, '.js-addToCart').prop('disabled', false);

      if (isDirectDelivery && externalStock) {
        qtyInput.data('max', externalStock).trigger('blur');
      }
    }

    if (isPhasedOut && isMasterClass) {
      CartStateManager.applyLowStockWarning(row, data, forecastStock, qtyInput);
    }
  }

  private static applyLowStockWarning(
    row: JQuery,
    data: StockAndPriceData,
    available: number,
    qtyInput: JQuery<HTMLInputElement>,
  ): void {
    const warning = RowReader.ownDescendants(row, '.js-lowStockWarning');
    const current = data.quantity ?? 1;
    if (current > available && available > 0) {
      qtyInput.data('max', available).trigger('blur');
      warning.find('p').text(
        MessageHelper.getMessageWithAttributes('eparts.product.lowStockRemaining', available),
      );
    } else if (available === 0) {
      warning.find('p').text(
        MessageHelper.getMessage('eparts.product.soldOut'),
      );
    }
  }
}
